import { useTranslation } from "react-i18next";

import { SERIES_KINDS } from "@/components_v2/Charts/Series/constants";
import SeriesCard from "@/features/certifications/analytics/components/SeriesCard";
import {
  CERTIFIED_COLOR,
  INTERVALS,
  TALL_CHART_HEIGHT,
} from "@/features/certifications/analytics/constants";
import {
  getBucketLabels,
  getProgressionSeries,
  getRampColor,
} from "@/features/certifications/analytics/utils";
import { ProgressionCardProps } from "@/features/certifications/analytics/types";

const ProgressionCard = ({
  data,
  isLoading,
  isError,
  isIntervalAdjusted,
}: ProgressionCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.progression";
  const points = data?.points ?? [];
  const modules = data ? getProgressionSeries(data) : [];
  const latest = points.at(-1);

  return (
    <SeriesCard
      title={t(`${prefix}.title`)}
      aside={
        latest ? (
          <span className="analytics-muted body-s-regular">
            {t(`${prefix}.total`, { count: latest.total })}
          </span>
        ) : undefined
      }
      info={[
        t(`${prefix}.info`),
        isIntervalAdjusted ? t(`${prefix}.intervalAdjusted`) : null,
      ]
        .filter(Boolean)
        .join(" ")}
      isLoading={isLoading}
      isError={isError}
      height={TALL_CHART_HEIGHT}
      stacked
      categoryLabel={t(
        `certification.admin.analytics.period.category.${data?.interval ?? INTERVALS.WEEK}`,
      )}
      labels={data ? getBucketLabels(points, data.interval) : []}
      getTooltipFooter={(index) =>
        t(`${prefix}.total`, { count: points[index]?.total ?? 0 })
      }
      series={[
        ...modules.map((module, index) => ({
          key: `module-${module.moduleId}`,
          label: t(`${prefix}.module`, {
            position: module.week,
            title: module.title,
          }),
          data: module.data,
          color: getRampColor(index, modules.length),
          kind: SERIES_KINDS.AREA,
        })),
        {
          key: "certified",
          label: t(`${prefix}.certified`),
          data: points.map((point) => point.certified),
          color: CERTIFIED_COLOR,
          kind: SERIES_KINDS.AREA,
        },
      ]}
    />
  );
};

export default ProgressionCard;
